namespace RioERP.Enquiry {
    export interface CustomerEnquiryForm {
        RowIds: Serenity.StringEditor;
        EStatus: Serenity.EnumEditor;
        FollowupDate: Serenity.DateEditor;
        HandledBy: Serenity.LookupEditor;
        EnquiryProducts: Serenity.LookupEditor;
    }

    export class CustomerEnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.CustomerEnquiryForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerEnquiryForm.init)  {
                CustomerEnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(CustomerEnquiryForm, [
                    'RowIds', w0,
                    'EStatus', w1,
                    'FollowupDate', w2,
                    'HandledBy', w3,
                    'EnquiryProducts', w3
                ]);
            }
        }
    }
}
